module.exports = __webpack_public_path__ + "static/media/medellin-12.3615f257.jpg";